import React, { useState } from "react";
import { useSelector } from "react-redux";
import Memories from "../components/dumb/tables/Memories";
import { extractIDsDataAsArray } from "../helpers/mapRow";
import useAuthEffect from "../hook/useAuthEffect";
import useEffectWithoutLoad from "../hook/useEffectWithoutLoad";
import useStatusThunk from "../hook/useStatusThunk";
import { fetchMemoriesByTask } from "../redux/ducks/memory";
const TaskMemoriesRoute = ({ match }) => {

    const taskID = match.params.taskID;
    const memories = useSelector(state => state.memory.memories);
    const taskMemories = useSelector(state => state.task.tasks[taskID]?.memories);
    const [rows, setRows] = useState([]);

    const [d_fetchMemoriesByTask, status, error, e] = useStatusThunk(fetchMemoriesByTask);

    useAuthEffect(() => d_fetchMemoriesByTask({ taskID }), []);

    useEffectWithoutLoad(() => {
        setRows(extractIDsDataAsArray(taskMemories, memories));
    }, [memories, taskMemories]);

    return (
        <React.Fragment>
            <div className="columns-container">

                <div className="column column--primary">
                    <Memories rows={rows} titleContent=" " memoryURL={"/task/" + taskID + "/memory/:memoryID/"} taskID={taskID} />
                </div>
            </div >
        </React.Fragment>
    )
}

export default TaskMemoriesRoute;